module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fullCalendar) ? _c('div', {
    staticClass: "navigator"
  }, [_c('div', {
    staticClass: "date-scroller d-flex align-items-center",
    on: {
      "click": _vm.backToList
    }
  }, [_c('arrow', {
    staticClass: "mr-1",
    attrs: {
      "direction": "left",
      "amount": "-1"
    },
    on: {
      "updateArrowDate": _vm.updateArrowDate
    }
  }), _vm._v(" "), _c('arrow', {
    attrs: {
      "direction": "right",
      "amount": "1"
    },
    on: {
      "updateArrowDate": _vm.updateArrowDate
    }
  }), _vm._v(" "), _c('span', [(_vm.getCurrentView == 'agendaDay') ? _c('vue-datepicker', {
    attrs: {
      "value": _vm.getExpandedDay,
      "monday-first": false,
      "format": "dd-MM-yyyy",
      "input-class": "",
      "required": false
    },
    on: {
      "selected": _vm.setExpandedDay
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.getCurrentView != 'agendaDay') ? _c('span', {
    staticClass: "fs-largest text-center px-2"
  }, [_vm._v("\n            " + _vm._s(_vm.fullCalendar.view.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingEvents) ? _c('div', {
    staticClass: "loader ml-3"
  }, [_vm._v("Loading...")]) : _vm._e()], 1), _vm._v(" "), (_vm.fullCalendar) ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "btn-group d-flex"
  }, [_vm._l((_vm.periods), function(period) {
    return _c('button', {
      staticClass: "btn",
      class: {
        'bg-dark lightest': period.value == _vm.fullCalendar.view.name && !(period.value == 'agendaDay' && _vm.highlightTodayButton), 'bg-faded dark': period.value != _vm.fullCalendar.view.name || (period.value == 'agendaDay' && _vm.highlightTodayButton)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeView(period)
        }
      }
    }, [_vm._v(_vm._s(period.label))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'bg-dark lightest': _vm.highlightTodayButton, 'bg-faded dark': !_vm.highlightTodayButton
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToToday
    }
  }, [_vm._v("Today")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.accessPermissionFilter(['admin', 'supervisor'])) ? _c('div', {}, [_c('button', {
    staticClass: "btn ml-4 bg-dark",
    on: {
      "click": _vm.openCreateEvent
    }
  }, [_c('i', {
    staticClass: "ico ico-add mt-1"
  }), _vm._v("New event")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-31bcad7f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bcad7f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Navigator.vue
// module id = 1647
// module chunks = 0